/**
 * created this class to play jail break animation In Respin Mode
 * before initial Win Presentation
 */
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SequentiallyBetLineInitialWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/initial/sequentially/SequentiallyBetLineInitialWPController";
import {Timeline} from "gsap";
import {BarbarianFuryGameConfig} from '../BarbarianFuryGameConfig';
import {BarbarianFuryGameMode} from "../gamemode/BarbarianFuryGameMode";
import {BarbarianFuryParsedGameData} from "../server/data/BarbarianFuryParsedGameData";
import {BarbarianFuryReelSymbol} from "../symbols/BarbarianFuryReelSymbol";


export class BarbarianJailBreak extends SequentiallyBetLineInitialWPController {

    private _mode:string;

    constructor(indexes:[number, number]) {
        super(indexes, {
            name : "InitialWin",
            hasWinCountUp : false,
            shouldPlayBetLine : false,
            skippable : false,
            betWinMode : BetWinMode.BET_LINE,
        });
    }

    protected parseFeatureGameData?(data:BarbarianFuryParsedGameData):void {
        this._mode = data.mode;
    }

    protected hasWin():boolean {
        return (this._mode.indexOf("RESPIN") !== -1);
    }

    protected addSymbolWinAnimationToTimeline(betLineWinData:IBetLineWinData, timeline:Timeline, startTime:number, symbol:BarbarianFuryReelSymbol, reelId:number, symbolId:number):number {
        let isFreeSpinMode = this._gameData!.mode.indexOf(BarbarianFuryGameMode.FREESPIN) > -1;
        if(((symbol.symName.indexOf("M1") > -1) ||
            (symbol.symName.indexOf("M2") > -1) ||
            (symbol.symName.indexOf("M3") > -1)) &&
            this._gameData!.mode.indexOf("RESPIN") !== -1) {
            timeline.add(() => {
                const symbolAnimation:Timeline = symbol.changeState({
                        state : BarbarianFuryGameConfig.instance.SYMBOL_STATES.initialWin,
                        fadeInDuration : 0
                    }, undefined,
                    undefined,
                    (!this._gameData!.isBigWin && !isFreeSpinMode && symbolId === 0) ? this._gameData!.currentWinRatio : 1)! // FUGLY! // TODO: currently not used
            }, 0);
        }
        timeline.add(() => {
        }, reelId * 0.7);
        return timeline.duration();
    }
}